import { supabase } from "@/integrations/supabase/client";

/**
 * Instrumentation for learning gates.
 * Every gate logs shown / completed / abandoned with duration so we can judge
 * whether an involuntary nudge actually teaches — or just costs a tap.
 * Best-effort and fire-and-forget: telemetry never blocks a student's action.
 */

export type GateName = "thesis" | "retro" | "direction-call" | "finfox-question" | "money-basics";
export type GateStatus = "shown" | "completed" | "abandoned";

/** Stable pilot arm so a student never flips mid-pilot. */
export const pilotArm = (userId?: string | null): "A" | "B" => {
  if (!userId) return "B";
  let hash = 0;
  for (let i = 0; i < userId.length; i++) hash = (hash * 31 + userId.charCodeAt(i)) % 1_000_003;
  return hash % 2 === 0 ? "A" : "B";
};

export const logGateEvent = (opts: {
  userId?: string | null;
  gate: GateName;
  status: GateStatus;
  concept?: string;
  correct?: boolean | null;
  durationMs?: number;
  symbol?: string;
}) => {
  if (!opts.userId) return;
  void supabase
    .from("learning_events")
    .insert({
      user_id: opts.userId,
      gate: opts.gate,
      status: opts.status,
      concept: opts.concept ?? null,
      correct: opts.correct ?? null,
      duration_ms: opts.durationMs ?? null,
      symbol: opts.symbol ?? null,
      arm: pilotArm(opts.userId),
    })
    .then(
      () => undefined,
      () => undefined,
    );
};

/** Small helper for timing a gate from mount to resolution. */
export const startGateTimer = () => {
  const t0 = Date.now();
  return () => Date.now() - t0;
};
